import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../LanguageContext';
import { FaSun } from 'react-icons/fa';

const Header = ({ scrolled }) => {
  const { language, toggleLanguage, t } = useLanguage();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white shadow-lg py-3'
          : 'bg-transparent py-5'
      }`}
      data-testid="header"
    >
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center">
          <motion.div
            whileHover={{ scale: 1.05 }}
            className="flex items-center space-x-2 cursor-pointer"
            onClick={() => scrollToSection('home')}
            data-testid="logo"
          >
            <div className="w-10 h-10 bg-gradient-to-br from-solar-400 to-energy-500 rounded-full flex items-center justify-center">
              <FaSun className="text-white text-xl" />
            </div>
            <span className={`font-bold text-xl ${
              scrolled ? 'text-gray-800' : 'text-white'
            }`}>
              PI ENERGI
            </span>
          </motion.div>

          <nav className="hidden md:flex items-center space-x-8">
            {['home', 'about', 'activities', 'contact'].map((section) => (
              <motion.button
                key={section}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => scrollToSection(section)}
                className={`font-medium transition-colors ${
                  scrolled
                    ? 'text-gray-700 hover:text-solar-600'
                    : 'text-white hover:text-solar-200'
                }`}
                data-testid={`nav-${section}`}
              >
                {t.nav[section]}
              </motion.button>
            ))}
          </nav>

          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={toggleLanguage}
            className={`flex items-center space-x-2 px-4 py-2 rounded-full transition-all ${
              scrolled
                ? 'bg-solar-100 text-solar-700 hover:bg-solar-200'
                : 'bg-white/20 text-white hover:bg-white/30 backdrop-blur-sm'
            }`}
            data-testid="language-toggle"
          >
            <span className="font-semibold">{language.toUpperCase()}</span>
            <span className="text-xs">⇄</span>
          </motion.button>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;